'use strict';

import angular from 'angular';

export default angular.module('pizzutoAutopartesApp.constants', [])
    .constant('appConfig', require('../../server/config/environment/shared'))
    .constant('ARTICULOS_URL', '/api/articulos')
    .constant('ORDENES_URL', '/api/ordenes')
    .constant('USUARIOS_URL', '/api/users')
    .constant('ARTICULO_CATEGORIA_URL', '/api/articulos/categoria')
    .constant('CATEGORIAS_URL', '/api/utils/categorias')
    .constant('IMAGE_UPLOAD_URL', '/api/articulos/images/upload')
    .constant('FILE_UPLOAD_URL', '/api/descargas/file/upload')
    .constant('QR_UPLOAD_URL', '/api/descargas/qr/upload')
    .constant('UTIL_URL', '/api/utils')
    .constant('DESCARGAS_URL', '/api/descargas')
    .name;



// WEBPACK FOOTER //
// ./client/app/app.constants.js